export const permissions = {
  FULL_ACCESS: 'FULL_ACCESS',
  SUPERVISOR: 'SUPERVISOR',
  EDIT_CHARGER_DETAILS: 'EDIT_CHARGER_DETAILS',
  EDIT_CHARGER_AVAILABILITY: 'EDIT_CHARGER_AVAILABILITY',
  UPDATE_CHARGER_FW: 'UPDATE_CHARGER_FW',
  RESET_NOTIFICATION: 'RESET_NOTIFICATION',
  RESET_GIR: 'RESET_GIR',
  RESET_I2P2_BOARD: 'RESET_I2P2_BOARD',
  RESET_PWB1: 'RESET_PWB1',
  EDIT_COMMON_DICTIONARIES: 'EDIT_COMMON_DICTIONARIES',
  EDIT_USER_RELATED_DICTIONARIES: 'EDIT_USER_RELATED_DICTIONARIES',
  VIEW_FW_UPDATE_PAGE: 'VIEW_FW_UPDATE_PAGE',
  VIEW_REPORTS: 'VIEW_REPORTS',
  VIEW_CHARGER_CONFIGURATION: 'VIEW_CHARGER_CONFIGURATION',
  EDIT_CHARGER_CONFIGURATION: 'EDIT_CHARGER_CONFIGURATION',
  CREATE_CHARGER_TASK: 'CREATE_CHARGER_TASK',
  VIEW_CHARGER_TASK: 'VIEW_CHARGER_TASK',
  CONTROL_CHARGER_TASK: 'CONTROL_CHARGER_TASK',
  TELEMETRY_METRICS: 'TELEMETRY_METRICS',
  VIEW_CHARGER_TELEMETRY: 'VIEW_CHARGER_TELEMETRY',
  EDIT_PLAZA: 'EDIT_PLAZA',
};

export const permissionsLabels = {
  [permissions.FULL_ACCESS]: 'Full access',
  [permissions.EDIT_CHARGER_DETAILS]: 'Charger Info → Details tab → All tabs → All fields / Edit',
  [permissions.EDIT_CHARGER_AVAILABILITY]: 'Charger Info → Monitored to Available Status, Connector State / Edit',
  [permissions.UPDATE_CHARGER_FW]: 'Charger Details, FW Update → FW Update button',
  [permissions.VIEW_FW_UPDATE_PAGE]: 'FW Update page',
  [permissions.RESET_GIR]: 'Charger Info → Details tab → Reset buttons → GIR Reset',
  [permissions.RESET_NOTIFICATION]: 'Charger Info → Details tab → Reset buttons → Notification Reset',
  [permissions.RESET_I2P2_BOARD]: 'Charger Info → Details tab → Reset buttons → Board Reset (Monitor Board Reset)',
  [permissions.RESET_PWB1]: 'Charger Info → Details tab → Reset buttons → PWB1 Reset',
  [permissions.EDIT_COMMON_DICTIONARIES]: 'Admin Tools → All screens',
  [permissions.EDIT_USER_RELATED_DICTIONARIES]: 'Admin Tools → Accounts, Access Levels screens',
  [permissions.VIEW_REPORTS]: 'All Reports',
  [permissions.VIEW_CHARGER_CONFIGURATION]: 'Charger Info → Configuration Tab / Configuration Update Page → View',
  [permissions.EDIT_CHARGER_CONFIGURATION]: 'Charger Info → Configuration Tab / Configuration Update Page → Edit',
  [permissions.CREATE_CHARGER_TASK]: 'Charger Info → Details tab → Create Task (Copy, Cancel)',
  [permissions.VIEW_CHARGER_TASK]: 'Charger Info → Details tab → Tasks tab → View',
  [permissions.CONTROL_CHARGER_TASK]: 'Charger Info → Details tab → Tasks tab → Control Task (Upload, Download)',
  [permissions.VIEW_CHARGER_TELEMETRY]: 'Charger Info → Details tab → Telemetry tab → View',
  [permissions.EDIT_PLAZA]: 'Plaza Details and Editor → Add / Edit',
  [permissions.SUPERVISOR]: 'Multi-tenant environment owner',
};
